export const SUBTOTAL_LABEL = 'Subtotal';
export const TAX_LABEL = 'Taxes';
export const TIP_LABEL = 'Tips';
export const FEES_LABEL = 'Fees';
export const FULFILLMENT_LABEL = 'Fulfillment Fee';
export const DISCOUNTS_LABEL = 'Discounts';
export const TOTAL_LABEL = 'Total';
